import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button } from '../../components/ui/button'
import { api } from '../../lib/api'

export default function AcceptInvite() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  const [status, setStatus] = useState(token ? 'loading' : 'missing-token')
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)

  useEffect(() => {
    if (!token) return
    let cancelled = false
    ;(async () => {
      try {
        const res = await api.acceptInvite(token)
        if (!cancelled) {
          setResult(res)
          setStatus('done')
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to accept invite')
          setStatus('error')
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [token])

  if (status === 'missing-token') {
    return <div className="p-8 max-w-md mx-auto text-center">This invite link is missing its token.</div>
  }
  if (status === 'loading') {
    return <div className="p-8 max-w-md mx-auto text-center text-charcoal-muted">Accepting your invite...</div>
  }
  if (status === 'error') {
    return <div className="p-8 max-w-md mx-auto text-center text-red-600">{error}</div>
  }

  return (
    <div className="p-8 max-w-md mx-auto text-center space-y-4">
      <p>You're in! You now have {result.role === 'parish-admin' ? 'parish admin' : 'member'} access.</p>
      <Button
        onClick={() =>
          window.location.assign(
            result.role === 'parish-admin' ? '/app/parish/settings/team' : '/app/donor/parish',
          )
        }
      >
        Continue
      </Button>
    </div>
  )
}
